<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h2>Kampanya Ekle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Kampanya Başlık</h4>
          <v-text-field
            v-model="campaign.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Mobil Başlık</h4>
          <v-text-field
            v-model="campaign.shortDescription"
            maxlength="255"
            counter="255"
            :rules="shortDescriptionRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <h4>Son Kullanım Tarihi</h4>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="campaign.endDate"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="campaign.endDate"
              :min="new Date().toISOString().substr(0, 10)"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row
        v-if="
          campaign.type === 'Partnership' || campaign.type === 'CouponCode'
        "
      >
        <v-col cols="12" md="4" sm="3">
          <h4>Kod tipi</h4>
          <v-select
            v-model="campaign.codeType"
            :items="codeTypeList"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            required
          ></v-select>
        </v-col>
        <v-col v-if="campaign.codeType !== 1" cols="12" md="4">
          <h4>
            Toplam Kod Adedi
          </h4>
          <v-text-field
            v-model="campaign.userCount"
            name="name"
            value="value"
            type="number"
            @input="handleInput"
            :rules="
              campaign.codeType === 'General'
                ? codeUsageRules
                : campaign.codeType === 'Unique'
                ? codeCountRules
                : noRule
            "
            min="1"
            required
          ></v-text-field>
        </v-col>

        <v-col v-if="campaign.codeType === 'General'" cols="12" md="4">
          <h4>Kampanya Kodu</h4>
          <v-text-field
            v-model="campaign.code"
            @keyup="uppercase"
            maxlength="8"
            minlenght="6"
            counter="8"
            required
            :rules="campaign.codeType === 'General' ? codeRules : noRule"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="campaign.description"
            maxlength="2000"
            rows="1"
            auto-grow
            counter="2000"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Link
            <v-icon
              style="font-size: 17px;"
              v-if="!alertLink"
              color="#4d48f9"
              @click="alertLink = true"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertLink"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Dış Link eklerken http, https protokollerinin girilmesi
              gereklidir.
              <br />
              Örneğin: http://frink.com.tr, https://frink.com.tr
            </v-alert>
          </h4>
          <v-text-field
            v-model="campaign.link"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="3">
          <h4>Link tipi</h4>
          <v-select
            v-model="campaign.campaignLinkType"
            :items="campaignLinkTypes"
            :disabled="campaign.link === ''"
            item-text="name"
            item-value="value"
            label="Link Tipi"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field
            v-model="campaign.linkText"
            :disabled="campaign.link === ''"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <h4>
            Öncelik
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Kampanyanın uygulamadaki sırasını belirtir.
            </v-alert>
          </h4>
          <v-text-field
            v-model="campaign.sortOrder"
            type="number"
            min="0"
            required
            @input="handleInput"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <h4>Ana Sayfada göster</h4>
          <v-checkbox
            v-model="campaign.isShownHomePage"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="campaign.active" color="#4d48f9"></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Görsel
            <v-icon
              style="font-size: 17px;"
              v-if="!infoImage"
              color="#4d48f9"
              @click="infoImage = true"
            >
              info
            </v-icon>
          </h4>

          <v-alert
            v-model="infoImage"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Görsel boyutu: 654x400
            <br />
            Format: JPG
            <br />
            Dosya boyutu: Maximum 350 KB
          </v-alert>
          <v-img
            style="cursor: pointer;"
            v-if="imgUrl !== '' && imgUrl !== undefined"
            :src="imgUrl"
            aspect-ratio="1.7"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            v-model="campaign.img"
            @change="previewFiles"
            label="Resim yükle"
            :rules="imageRules"
            required
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="merchantCampaignAdd()"
            :disabled="addButtonDisabled"
          >
            EKLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
  
        </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MerchantCampaign',
  data: () => ({
    alert: false,
    infoImage: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    descriptionRules: [
      (v) => !!v || 'Açıklama alanı zorunludur.',
      (v) => v.length <= 2000 || 'Maksimum 2000 karakter olmalıdır.',
    ],
    shortDescriptionRules: [
      (v) => !!v || 'Kısa açıklama alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    segmentationTypeRules: [
      (v) => !!v || 'Segmentasyon tipi alanı zorunludur.',
    ],

    discountRules: [
      (v) =>
        parseFloat(v) >= 1 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
      (v) =>
        parseFloat(v) <= 25000 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
    ],
    codeRules: [
      (v) => !!v || 'Kampanya kodu alanı zorunludur.',
      (v) =>
        /^\w+$/.test(v) ||
        'Genel kod yalnızca ingilizce karakterlerden oluşmalıdır.',
      (v) => v.length >= 6 || 'Genel kod 6-8 karakter olmalıdır.',
      (v) => v.length <= 8 || 'Genel kod 6-8 karakter olmalıdır.',
    ],
    noRule: [],
    codeCountRules: [
      (v) => parseInt(v) >= 1 || 'Kod miktarı ez az 1 olmalıdır.',
    ],
    codeUsageRules: [
      (v) =>
        parseInt(v) >= 1 || "Kullanım sayısı miktarı 1'den küçük olmamalıdır.",
    ],
    imgUrl: '',
    imageRules: [
      (v) => !!v || 'Resim alanı zorunludur.',
      (v) =>
        (v && v.size <= 350 * 1024) ||
        'Dosya boyutu en fazla 350 KB olmalıdır.',
    ],
    campaignLinkTypes: [
      {
        name: 'İç Link',
        value: 'InternalLink',
      },
      {
        name: 'Dış Link',
        value: 'ExternalLink',
      },
    ],
    campaign: {
      title: '',
      img: null,
      description: '',
      shortDescription: '',
      link: '',
      discount: 0.0,
      linkText: '',
      campaignLinkType: 'InternalLink',
      active: true,
      codeType: 1,
      type: 'General',
      segmentType: 'NoSegment',
      usageCount: 1,
      userCount: 1,
      shown: true,
      endDate: new Date().toISOString().substr(0, 10),
      priority: 0,
      code: null,
    },
    menu: false,
    usageCountLimitOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],

    campaignTypeList: [
      {
        name: 'Genel Kampanya',
        value: 'General',
      },
      {
        name: 'Kupon Kodu',
        value: 'CouponCode',
      },
      {
        name: 'İş Birliği',
        value: 'Partnership',
      },
    ],
    codeTypeList: [
      {
        name: 'Genel Kod',
        value: 'General',
      },
      {
        name: 'Unique Kod',
        value: 'Unique',
      },
      {
        name: 'No Code',
        value: 'NoCode',
      },
    ],
    errorList: [],
    dialog: false,
    addButtonDisabled: false
  }),
  methods: {
    ...mapActions(['addMerchantCampaign']),
    // uppercase() {
    //   this.campaign.code = this.campaign.code.toUpperCase()
    // },
    campaignTypeChange(data) {
      if (
        data !== 'General' &&
        (!!this.campaign.codeType || this.campaign.codeType === 'NO_CODE')
      )
        this.campaign.codeType = 'General'
    },
    routeCampaigns() {
      this.$router.push('/dashboard/merchant-campaigns')
    },
    handleInput(item) {
      if (item.includes('.')) this.campaign.userCount = item.replace('.', '')
    },
    // getBase64(file) {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader()
    //     reader.readAsDataURL(file)
    //     reader.onload = () => resolve(reader.result.split(',')[1])
    //     reader.onerror = (error) => reject(error)
    //   })
    // },
    merchantCampaignAdd() {
      this.addButtonDisabled = true
      if (this.$refs.form.validate()) {
        if (this.campaign.link !== '' && this.campaign.linkText === '') {
          alert('Link metni alanı dolu olmalıdır')
          return
        }
        this.snackbar = true
        if (this.campaign.img == null) {
          alert('Resim alanı dolu olmalıdır')
          return
        }
        this.addMerchantCampaign(this.campaign)
          .then((response) => {
            if (response.payload) {
              this.routeCampaigns()
            } else {
              alert(response.friendlyMessage.message)
            }
          })
          .catch((err) => {
            const errors = err.response.data.errors;
            if (errors && Object.keys(err.response.data.errors).length) {
              if (errors['Link']) {
                alert('Link alanını kontrol edin')
                return;
              }
            }
            alert(err)
          })
          .finally(() => {
            this.addButtonDisabled = false
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)
        this.errorList = errors
        this.dialog = true
        this.addButtonDisabled = false
      }
    },
    previewFiles() {
      if (this.campaign.img === undefined) {
        this.imgUrl = ''
      } else {
        const file = this.campaign.img
        this.imgUrl = URL.createObjectURL(file)
      }
    },
  },
  watch: {
    watch: {
      'campaign.link': function (newVal) {
        //to work with changes in someOtherProp
        console.log(newVal)
      },
    },
  },
}
</script>
